import { createRouter, createWebHistory } from 'vue-router'
import regRoute from './register';
import pageRoute from './page';
import userRoute from './user';
import statisticsRoute from './statistics'
import guessRoute from './guess'
import galleryRoute from './gallery'
import masterRoute from './master'
import toolRoute from './tool'
import meRoute from './me/me';
import discoverRoute from './discover';
import platformRoute from './platform'
import wechatRoute from './wechat'

import main from '@/views/main.vue';
import index from '@/views/page/index.vue';

const me = () => import(/* webpackChunkName: "tab-me" */ '@/views/me/index.vue')
const discover = () => import(/* webpackChunkName: "tab-discover" */ '@/views/discover/index.vue')
const platform = () => import(/* webpackChunkName: "tab-platform" */ '@/views/platform/index.vue')
const gp = () => import(/* webpackChunkName: "gp" */ '@/views/page/materials/gp.vue')
const gpList = () => import(/* webpackChunkName: "gp-list" */ '@/views/page/materials/gpList.vue')

const routes = [
  {
    path: '/',
    name: 'home',
    component: main,
    redirect: '/index',
    children: [
      {
        path: '/index',
        name: 'indexs',
        component: index,
        meta: {
          keepAlive: true,
          top: true
        },
      },
      {
        path: '/me',
        name: 'mes',
        component: me,
      },
      {
        path: '/discover',
        name: 'discovers',
        meta: {
          keepAlive: true,
        },
        component: discover
      },
      {
        path: '/platform',
        name: 'platforms',
        meta: {
          keepAlive: true,
        },
        component: platform
      },
    ]
  },
  {
    path: '/gp',
    name: 'gp',
    component: gp
  },
  {
    path: '/list/gp',
    name: 'listgp',
    component: gpList
  },
]
routes.push(...regRoute, ...pageRoute, ...userRoute, ...statisticsRoute, ...guessRoute, ...galleryRoute, ...masterRoute, ...toolRoute, ...meRoute, ...discoverRoute, ...platformRoute, ...wechatRoute);

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(function (to, from, next) {
  if (localStorage.getItem('config') == null) {
    document.title = '77图库';
  } else {
    document.title = JSON.parse(localStorage.getItem('config')).name;
  }

  if (!to.meta.top) {
    window.scrollTo(0, 0)
  }
  if (to.meta.needLogin) {
    if (localStorage.getItem("Authorization")) {
      next();
    } else {
      next({
        name: "login"
      });
    }
  } else {
    next();
  }
});

router.beforeEach(function (to, from, next) {
  if (to.matched.length === 0) {
    next({
      name: "indexs"
    });

  } else {
    next();
  }
});

export default router
